import React, { useState } from "react";

function Footer() {
  const ano = new Date().getFullYear();
  const [nome, setNome] = useState("");

  return (
    <section id="footer">
      <div>
        <ul className="list-unstyled list-inline social text-center">

         
        </ul>
      </div>

      {/* CONTATO */}      

      <p>Desenvolvido por Silvio Paiva - {ano}</p>
    </section>
  );
}

export default Footer;
